import 'intl-tel-input/build/css/intlTelInput.css';

import intlTelInput from 'intl-tel-input';
import intlTelInputUtilsUrl from 'intl-tel-input/build/js/utils?url';

import { isEmailValid } from '@/shared/utils/email';
import { klaviyoIdentify } from '@/shared/utils/tracking';

const inputPhone = document.querySelector<HTMLInputElement>('#inputPhone');
const inputPhoneErrorMsg = document.querySelector('#inputPhoneErrorMsg');
const inputPhoneValidMsg = document.querySelector('#inputPhoneValidMsg');
const inputEmail = document.querySelector<HTMLInputElement>('#inputEmail');
const inputEmailErrorMsg = document.querySelector('#inputEmailErrorMsg');
const inputEmailValidMsg = document.querySelector('#inputEmailValidMsg');
const contactForm = document.querySelector('#contactForm');
const submitButton = document.querySelector('#submitButton');
const thankyouMessage = document.querySelector('#thankyouMessage');
const errorMessage = document.querySelector('#errorMessage');
const endpoint = contactForm?.getAttribute('data-customer-service-endpoint');
const inputHiddenSubjectCategory = document.querySelector<HTMLInputElement>(
  '#inputHiddenSubjectCategory'
);
const inputCategory =
  document.querySelector<HTMLInputElement>('#inputCategory');

// Show user friendly subject in the autoreply that we send to the customer
if (inputHiddenSubjectCategory) {
  inputCategory?.addEventListener('change', (e) => {
    const categorySelect = e.target as HTMLSelectElement;
    const selectedLabel = categorySelect.selectedOptions[0].textContent?.trim();
    if (!selectedLabel) {
      return;
    }
    inputHiddenSubjectCategory.value = selectedLabel;
  });
}

// Needed for phone validation script
const errorMap = contactForm?.getAttribute('data-tel-error-msg')?.split(',');
const shopLocale = contactForm?.getAttribute('data-shop-locale');

let iti: intlTelInput.Plugin | undefined;

if (inputPhone && shopLocale) {
  iti = intlTelInput(inputPhone, {
    nationalMode: true,
    // @ts-expect-error -- This option DOES exist, but the type definitions are older than the module version https://intl-tel-input.com/examples/show-selected-dial-code.html
    showSelectedDialCode: true,
    initialCountry: shopLocale,
    containerClass: 'w-full',
    utilsScript: intlTelInputUtilsUrl
  });
}

let phoneValid = true;
const validatePhone = (e: Event) => {
  // if user has typed invalid number before, use validation on keyup else: only validate on blur
  if (e.type === 'keyup' && phoneValid === true) {
    return;
  }
  if (inputPhone?.value.trim() && iti) {
    if (iti.isValidNumber()) {
      inputPhoneValidMsg?.classList.remove('hidden');
      inputPhoneErrorMsg?.classList.add('hidden');
    } else {
      phoneValid = false;
      const errorCode = iti.getValidationError();
      inputPhoneValidMsg?.classList.add('hidden');
      if (inputPhoneErrorMsg) {
        inputPhoneErrorMsg.innerHTML =
          errorMap && errorMap[errorCode]
            ? errorMap[errorCode]
            : 'Invalid number';
        inputPhoneErrorMsg.classList.remove('hidden');
      }
    }
  }
};

let emailValid = true;
const validateEmail = (e: Event) => {
  // if user has typed invalid number before, use validation on keyup else: only validate on blur
  if (e.type === 'keyup' && emailValid === true) {
    return;
  }
  const email = inputEmail?.value.trim();
  if (email && isEmailValid(email)) {
    emailValid = true;
    inputEmailErrorMsg?.classList.add('hidden');
    inputEmailValidMsg?.classList.remove('hidden');
  } else {
    emailValid = false;
    inputEmailErrorMsg?.classList.remove('hidden');
    inputEmailValidMsg?.classList.add('hidden');
  }
};

const handleFormSubmit = (e: Event) => {
  e.preventDefault();
  submitButton?.setAttribute('disabled', '');
  if (!contactForm) return;

  const category =
    contactForm.querySelector<HTMLInputElement>('#inputCategory')?.value;
  const name = contactForm.querySelector<HTMLInputElement>('#inputName')?.value;
  const order =
    contactForm.querySelector<HTMLInputElement>('#inputOrder')?.value;
  const email = contactForm
    .querySelector<HTMLInputElement>('#inputEmail')
    ?.value.trim();
  const message =
    contactForm.querySelector<HTMLInputElement>('#inputMessage')?.value;
  const telephoneEl =
    contactForm.querySelector<HTMLInputElement>('#inputPhone');
  const subjectPrefix = contactForm.querySelector<HTMLInputElement>(
    '#inputHiddenSubjectPrefix'
  )?.value;
  const subjectCategory = contactForm.querySelector<HTMLInputElement>(
    '#inputHiddenSubjectCategory'
  )?.value;

  if (telephoneEl && telephoneEl.value.trim() && iti && !iti.isValidNumber()) {
    telephoneEl?.focus();
    return;
  }

  if (email) {
    klaviyoIdentify({
      email,
      firstName: name?.trim().split(/\s+/)[0] || undefined
    });
  }

  const formData = new FormData();
  formData.append('category', category || '');
  formData.append('name', name || '');
  formData.append('order', order || '');
  formData.append('email', email || '');
  formData.append('subject', `${subjectPrefix} ${subjectCategory}` || '');
  formData.append('phone', iti ? iti.getNumber() : telephoneEl?.value || '');
  formData.append('message', message || '');

  if (!endpoint) throw new Error('Contact form input endpoint not defined');

  fetch(endpoint, {
    method: 'POST',
    body: formData
  })
    .then((r) => r.json())
    .then(() => {
      thankyouMessage?.classList.remove('hidden');
      contactForm.classList.add('hidden');
      window.scroll({ top: 0, behavior: 'smooth' });
    })
    .catch((e) => {
      submitButton?.removeAttribute('disabled');
      if (errorMessage) {
        errorMessage.classList.remove('hidden');
        errorMessage.innerHTML = e;
      }
      window.scroll({ top: 0, behavior: 'smooth' });
    });
};

contactForm?.addEventListener('submit', handleFormSubmit);
inputPhone?.addEventListener('blur', validatePhone);
inputPhone?.addEventListener('keyup', validatePhone);
inputEmail?.addEventListener('blur', validateEmail);
inputEmail?.addEventListener('keyup', validateEmail);
